
$(document).ready(function () {
    $('.sidebar').find('li').removeClass('active');
    $('.sidebar ').find('li.contactlink').addClass('active');
})